/**
 * @generated SignedSource<<aef9996ff1d917cdaa2838f6ff7740e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StarButtonEmbedCardStarFragment$data = {
  readonly viewer: {
    readonly favoritedSummary: {
      readonly isFavorite: boolean;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "StarButtonEmbedCardStarFragment";
};
export type StarButtonEmbedCardStarFragment$key = {
  readonly " $data"?: StarButtonEmbedCardStarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonEmbedCardStarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StarButtonEmbedCardStarFragment",
  "selections": [
    {
      "concreteType": "ConfluenceContentViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceFavoritedSummary",
          "kind": "LinkedField",
          "name": "favoritedSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavorite"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluenceEmbed"
};

(node as any).hash = "dae3be06d0fda145c168470989cbd584";

export default node;
